import { Pill } from './SelectablePill.styles';
import type { SelectablePillProps } from './SelectablePill.types';

export function SelectablePill({
  label,
  variant = 'outline',
  selected = false,
  onClick,
  disabled,
}: SelectablePillProps) {
  if (variant === 'display') {
    return (
      <Pill as="span" data-variant="display">
        {label}
      </Pill>
    );
  }

  return (
    <Pill
      type="button"
      data-variant="outline"
      data-selected={selected}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
    >
      {label}
    </Pill>
  );
}
